import { writable } from "svelte/store";

/**
 * Initialize body dimensions store.
 */
const { subscribe, update, set } = writable({
  "length-weight": {
    length: null,
    weight: null,
    bmi: null,
  },
  "length-weight-partner": {
    length: null,
    weight: null,
    bmi: null,
  },
});

/**
 * Resets the body dimensions to its original state.
 */
export function reset() {
  set({
    "length-weight": {
      length: null,
      weight: null,
      bmi: null,
    },
    "length-weight-partner": {
      length: null,
      weight: null,
      bmi: null,
    },
  });
}

/**
 * Returns the firmness according to the mattress type and BMI.
 */
export function getFirmness(mattress: string, bmi: number) {
  switch (mattress) {
    case "elite":
    case "elysium":
    case "evolve":
      if (bmi < 23.9) return "soft";
      if (bmi >= 23.9 && bmi <= 27.8) return "medium";

      return "hard";
    case "one":
    case "two":
      if (bmi < 26.5) return "medium";

      return "hard";
  }
}

/**
 * Export the body dimensions store.
 */
export const bodyDimensions = {
  subscribe,
  reset,
  set,
  update,
};
